import { SortingDirection } from "enums";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type GenericFiltersMap } from "../../../../../utils/filterUtils";
import { createFiltersSlice, type FiltersState } from "../../../../Application/slices/createFiltersSlice";
import { type EventFilterPropertyNames } from "../../types/state";

export const initialState: FiltersState<EventFilterPropertyNames> = {
  filterOptions: {} as GenericFiltersMap<EventFilterPropertyNames>,
  appliedFilter: {} as GenericFiltersMap<EventFilterPropertyNames>,
  isLoading: false,
  sortingDirection: SortingDirection.Descending,
  sortingColumnName: "Added",
};

const eventFilterSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Events,
    name: "overviewFilters",
  },
  initialState,
  reducers: {},
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  setSortingColumnName,
  setSortingDirection,
  resetSortingColumnName,
  resetSortingDirection,
} = eventFilterSlice.actions;

export type EventFiltersState = ReturnType<typeof eventFilterSlice.reducer>;

export const eventFiltersReducer = eventFilterSlice.reducer;
